import { render, staticRenderFns } from "./applyFriend.vue?vue&type=template&id=60b3fb79&scoped=true"
import script from "./applyFriend.vue?vue&type=script&lang=js"
export * from "./applyFriend.vue?vue&type=script&lang=js"
import style0 from "./applyFriend.vue?vue&type=style&index=0&id=60b3fb79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b3fb79",
  null
  
)

export default component.exports